
if ( typeof VideoBackgroundElement !== 'function' ) {

  class VideoBackgroundElement extends HTMLElement {

    constructor(){

      super();

      this._eventSuccess = new Event('success');
      this._eventFail = new Event('fail');
      const video = this.querySelector('video');
      video.addEventListener('error', e=>{
        this.switchFallback();
      })
      video.addEventListener('playing', e=>{
        if ( ! this.classList.contains('loaded') ) {
          this.classList.add('loaded');
          this.dispatchEvent(this._eventSuccess);
        }
      })
      video.addEventListener('stalled', e=>{
        if ( ! this.classList.contains('loaded') ) {
          this.switchFallback();
        }
      })

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        if ( ( entries[0].target.querySelector('video-background-element') && ! entries[0].target.querySelector('video-background-element').classList.contains('loaded') ) || ( entries[0].tagName == 'video-background-element') && ! entries[0].target.classList.contains('loaded') ) {
          if ( this._started ) return;
          this._started = true;
          const playMp4 = () => {
            video.querySelectorAll('source').forEach(elm=>{
              elm.src = elm.dataset.src;
            });
            video.muted = true;
            video.load();
            video.play();
          };
          // Prefer the adaptive HLS playlist (720p/480p renditions sized to the element)
          const hlsUrl = window.VideoHLS && window.VideoHLS.sourceFromChildren(video);
          if ( hlsUrl ) {
            video.muted = true;
            window.VideoHLS.attach(video, hlsUrl).then(ok=>{
              if ( ok ) {
                video.play().catch(()=>{});
              } else {
                playMp4();
              }
            });
          } else {
            playMp4();
          }
        }
        observer.unobserve(this);
      }

      // Always defer loading through the observer, even for videos already
      // in the initial viewport (e.g. a hero/flex-grid video at the top of
      // the page). Loading it here synchronously, before the browser has
      // finished laying out and painting the page, competes with more
      // critical above-the-fold resources and slows down the perceived
      // page load. The observer still fires almost immediately for
      // already-visible elements, it just does so after the browser has
      // had a chance to get the rest of the page on screen first.
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`}).observe(this);
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`}).observe(this.parentElement);
      
    }

    switchFallback(){
      const fallback = this.parentElement.querySelector(`[data-video-background-fallback][data-id="${this.dataset.id}"]`);
      if ( fallback ) {
        fallback.append(fallback.querySelector('template').content.cloneNode(true));
        fallback.querySelector('img').setAttribute('srcset', fallback.querySelector('img').getAttribute('srcset'));
      }
      this.dispatchEvent(this._eventFail);
    }

  }

  if ( typeof customElements.get('video-background-element') == 'undefined' ) {
    customElements.define('video-background-element', VideoBackgroundElement);
  }

}

document.addEventListener('shopify:section:load', e=>{
  if ( e.target.classList.contains('mount-video-background') ) {
    setTimeout(()=>{
      e.target.querySelectorAll('video-background-element').forEach(elm=>{
        elm.querySelectorAll('source').forEach(source=>{
          source.src = source.dataset.src;
        })
        elm.querySelector('video').load();
        elm.querySelector('video').play();
      });
    }, 500);
  }
});